export default {
  owned: 'in Besitz',

  gem_prestigeStone: {
    name: 'Prestigestein',
    description: 'Erhalte Prestige-Währung abhängig vom besten Zyklus'
  },
  mining_goldenHammer: {
    name: 'Goldhammer',
    description: 'Stelle die bestmögliche Spitzhacke her'
  },
  village_ingredientBox: {
    name: 'Zutatenkiste',
    description: 'Enthält besondere Zutaten, welche nur in diesen Kisten gefunden werden können'
  },
  horde_manaPotion: {
    name: 'Manatrank',
    description: 'Stellt 50% vom maximalen Mana wieder her'
  },
  farm_basic: {
    name: 'Einfacher Dünger',
    description: ''
  },
  farm_flower: {
    name: 'Blumendünger',
    description: ''
  },
  farm_speedGrow: {
    name: 'Schnell-Wachs',
    description: ''
  },
  farm_richSoil: {
    name: 'Nahrhafte Erde',
    description: ''
  },
  farm_shiny: {
    name: 'Strahlender Dünger',
    description: ''
  },
  farm_juicy: {
    name: 'Saftiger Dünger',
    description: ''
  },
  farm_dissolving: {
    name: 'Pflanzenauflöser',
    description: ''
  },
  farm_potatoWater: {
    name: 'Kartoffelwasser',
    description: ''
  },
  farm_roseWater: {
    name: 'Rosenwasser',
    description: ''
  },
  farm_weedKiller: {
    name: 'Unkrautvernichter',
    description: ''
  },
  farm_turboGrow: {
    name: 'Turbo-Wachs',
    description: ''
  },
  farm_premium: {
    name: 'Premiumdünger',
    description: ''
  },
  farm_analyzing: {
    name: 'Analysedünger',
    description: ''
  },
  farm_superJuicy: {
    name: 'Super-saftig',
    description: ''
  },
  farm_pellets: {
    name: 'Pellets',
    description: ''
  },
  farm_supplementsS: {
    name: 'Zusatzstoffe (S)',
    description: ''
  },
  farm_supplementsM: {
    name: 'Zusatzstoffe (M)',
    description: ''
  },
  farm_supplementsL: {
    name: 'Zusatzstoffe (L)',
    description: ''
  },
  farm_supplementsXL: {
    name: 'Zusatzstoffe (XL)',
    description: ''
  },
  farm_supplementsXXL: {
    name: 'Zusatzstoffe (XXL)',
    description: ''
  },
  gallery_surpriseParty: {
    name: 'Überraschungsparty',
    description: 'Erhalte 500 Motivation'
  },
  treasure_upArrow: {
    name: 'Hoch-Pfeil',
    description: 'Erhöhe die Schatzstufe um 2'
  },
  treasure_expander: {
    name: 'Dehner',
    description: 'Die Schatzstufe erhöht sich mit der Zeit, kann aber nicht mehr mit Fragmenten verbessert werden'
  },
  treasure_wildcard: {
    name: 'Freikarte',
    description: 'Alle Effekte können neu gewählt werden'
  },
  treasure_eventStar: {
    name: 'Eventstern',
    description: 'Fügt Eventkraft als Effekt hinzu'
  },
};
